<script lang="ts">
  import { cx } from '@emotion/css';
  import { createEventDispatcher } from 'svelte';
  import { ResponsiveVars, TwistBox } from '@twist/core';
  import { jobsFiltersStore } from '$lib/stores/Careers/jobFiltersStore';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  const dispatch = createEventDispatcher();

  function handleResetFilters() {
    jobsFiltersStore.reset();

    dispatch('filters-change', $jobsFiltersStore);
  }

  let hasActiveFilters = false;

  jobsFiltersStore.subscribe((store) => {
    const { query, isRemote, locations, teams, employeeTypes, businessUnits } = store;
    hasActiveFilters =
      query.length > 0 ||
      isRemote ||
      locations.length > 0 ||
      teams.length > 0 ||
      employeeTypes.length > 0 ||
      businessUnits.length > 0;
  });

  const brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  const responsiveVars = new ResponsiveVars()
    .addFluid('button-px', brandReskinEnabled ? toFluidVarInput(15, 15) : toFluidVarInput(9, 9))
    .addFluid('button-py', brandReskinEnabled ? toFluidVarInput(9, 9) : toFluidVarInput(6, 6))
    .addFluid(
      'button-font-size',
      brandReskinEnabled ? toFluidVarInput(12, 12) : toFluidVarInput(15, 15)
    )
    .toCSS();
</script>

<TwistBox marginTop={toFluidVarInput(45, 0)} marginBottom={toFluidVarInput(30, 0)}>
  {#if brandReskinEnabled}
    <button
      class={cx(responsiveVars, 'reskin')}
      on:click={handleResetFilters}
      disabled={!hasActiveFilters}
    >
      Reset filters
    </button>
  {:else}
    <button class={responsiveVars} on:click={handleResetFilters}>Reset filters</button>
  {/if}
</TwistBox>

<style lang="scss">
  button {
    border: none;
    outline: none;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-family: var(--font-family-primary);
    font-size: var(--button-font-size);
    line-height: 120%;

    font-weight: 600;
    background: none;
    cursor: pointer;
    text-decoration: underline;
    padding: var(--button-py) var(--button-px);
    margin-right: calc(-1 * var(--button-px));

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      text-decoration: none;
      background: white;
      border-radius: 1000px;
    }

    &:active:not(:disabled) {
      opacity: 0.6;
    }
  }

  button.reskin {
    font-weight: 500;
    line-height: 100%;
    letter-spacing: 0.96px;
    text-decoration: none;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      background: var(--twist-color-gray-15); // background-depth-1-hover-color
      border-radius: 1000px;
    }

    &:active:not(:disabled) {
      opacity: 0.6;
    }

    &:disabled {
      cursor: not-allowed;
      color: var(--twist-color-gray-50); // text-default-disabled-color
    }
  }
</style>
